// Notifications translations
const dictNotifications = {
    notifications_popover_header: {
        th: "การแจ้งเตือน",
        en: "Notifications",
        ja: "通知",
    },
    notifications_empty: {
        th: "ไม่มีการแจ้งเตือน",
        en: "No notifications",
        ja: "通知はありません",
    },
    notifications_load_failed: {
        th: "โหลดไม่สำเร็จ",
        en: "Failed to load",
        ja: "読み込みに失敗しました",
    },

    notification_followed_title: {
        th: "ผู้ติดตามใหม่",
        en: "New follower",
        ja: "新しいフォロワー",
    },
    notification_followed_body: {
        th: "{{followerDisplayName}} ติดตามคุณ",
        en: "{{followerDisplayName}} followed you",
        ja: "{{followerDisplayName}}さんがあなたをフォローしました",
    },

    notification_followed_body_suffix: {
        th: " ติดตามคุณ",
        en: " followed you",
        ja: "さんがあなたをフォローしました",
    },

    notification_point_earned_title: {
        th: "คุณได้รับคะแนน",
        en: "You earned points",
        ja: "ポイントを獲得しました",
    },
    notification_point_earned_body: {
        th: "ได้รับ {{points}} คะแนนจาก {{ruleName}}",
        en: "You earned {{points}} pts from {{ruleName}}",
        ja: "{{ruleName}}で{{points}}pt獲得しました",
    },

    notification_system_announcement_title: {
        th: "ประกาศระบบ",
        en: "System announcement",
        ja: "システム告知",
    },
    notification_system_announcement_body: {
        th: "คืนนี้มีการบำรุงรักษาระบบตามกำหนดเวลา",
        en: "Scheduled system maintenance will take place tonight.",
        ja: "今夜、予定されているシステムメンテナンスを実施します。",
    },

    notification_affiliate_click_registered_title: {
        th: "บันทึกการคลิกแล้ว",
        en: "Click Recorded",
        ja: "クリックを記録しました",
    },
    notification_affiliate_click_registered_body: {
        th: "คลิกซื้อ {product_name} ผ่าน {platform} ถูกบันทึก โพสต์รูปเพื่อรับคะแนน (หมดอายุ {expires_at})",
        en: "Click to buy {product_name} via {platform} recorded. Post screenshot to earn points! (Expires {expires_at})",
        ja: "{platform} で {product_name} のクリックを記録。スクショ投稿でポイント獲得！（期限: {expires_at}）",
    },

    notification_point_earned_affiliate_title: {
        th: "ได้รับคะแนนแล้ว!",
        en: "Points Earned!",
        ja: "ポイント獲得！",
    },
    notification_point_earned_affiliate_body: {
        th: "ได้รับ {points} คะแนน จากการซื้อผ่าน {platform} — {product_name}",
        en: "You earned {points} points via {platform} — {product_name}",
        ja: "{platform} 購入で {points}ポイント獲得 — {product_name}",
    },

    notification_mentioned_title: {
        th: "ถูกกล่าวถึง",
        en: "You were mentioned",
        ja: "メンションされました",
    },
    notification_mentioned_body_suffix: {
        th: " กล่าวถึงคุณ",
        en: " mentioned you",
        ja: "さんがあなたをメンションしました",
    },
    notification_mentioned_body_on_post: {
        th: " ในโพสต์นี้",
        en: " on this post",
        ja: " (この投稿)",
    },
};

export { dictNotifications };
